import { render, staticRenderFns } from "./NutritionalLabel.vue?vue&type=template&id=2d2f154c"
import script from "./NutritionalLabel.vue?vue&type=script&lang=js"
export * from "./NutritionalLabel.vue?vue&type=script&lang=js"
import style0 from "./NutritionalLabel.vue?vue&type=style&index=0&id=2d2f154c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports